export const common = {
  nav: {
    home: 'Inicio',
    products: 'Productos',
    brands: 'Marcas',
    services: 'Servicios',
    contact: 'Contacto'
  },
  buttons: {
    requestInfo: 'Solicitar Información',
    loadMore: 'Cargar Más Productos',
    requestQuote: 'Solicitar Cotización',
    viewCatalog: 'Ver Catálogo',
    sendRequest: 'Enviar Solicitud'
  },
  hero: {
    title: 'IKIGAI Global Group Inc.',
    subtitle: 'Distribución directa de fábrica de máquinas industriales para coser sacos y repuestos originales. Especialistas en Newlong (Japón) y Union Special (Alemania) desde Miami, Florida.',
    cta1: 'Ver Catálogo',
    cta2: 'Solicitar Cotización'
  },
  sections: {
    valueProposition: {
      title: 'Nuestra Propuesta de Valor',
      subtitle: 'Distribución directa de fábrica con presencia global'
    },
    brands: {
      title: 'Marcas Líderes Mundiales',
      subtitle: 'Distribuidores de las mejores marcas de maquinaria industrial'
    },
    products: {
      title: 'Nuestros Productos',
      subtitle: 'Máquinas industriales y repuestos originales para optimizar sus operaciones',
      allProducts: 'Todos los Productos'
    },
    industries: {
      title: 'Sectores que Atendemos',
      subtitle: 'Soluciones especializadas para diferentes industrias'
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soporte integral para maximizar su inversión'
    },
    contact: {
      title: 'Contacto',
      subtitle: 'Estamos aquí para atenderle desde Miami, Florida'
    }
  }
};